import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import '@/plugins/cookies'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/filters'
import '@/directives'
import '@/plugins/vuelidate'
import '@/plugins/moment'
import '@/plugins/vue-meta'
import '@/plugins/v-mask'
import '@/plugins/highlightjs'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-178512551-1' }
  },
  router
)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
